module.exports = [{
  "name": "EyeIcon",
  "description": "",
  "code": "import React, {Component, Fragment} from \"react\";\n\nclass EyeIcon extends Component {\n\tconstructor(props) {\n\t\tsuper(props);\n\t\tthis.state = {}\n\t}\n\n\trender() {\n\t\treturn (\n\t\t\t<svg width=\"16\" height=\"16\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\">\n\t\t\t\t<g transform=\"matrix(.02146 0 0 .02146 1 1)\" fill=\"#4d4d4d\">\n\t\t\t\t\t<path\n\t\t\t\t\t\td=\"m466.07 161.53c-205.6 0-382.8 121.2-464.2 296.1-2.5 5.3-2.5 11.5 0 16.9 81.4 174.9 258.6 296.1 464.2 296.1 205.6 0 382.8-121.2 464.2-296.1 2.5-5.3 2.5-11.5 0-16.9-81.4-174.9-258.6-296.1-464.2-296.1m0 514.7c-116.1 0-210.1-94.1-210.1-210.1 0-116.1 94.1-210.1 210.1-210.1 116.1 0 210.1 94.1 210.1 210.1 0 116-94.1 210.1-210.1 210.1\"/>\n\t\t\t\t\t<circle cx=\"466.08\" cy=\"466.02\" r=\"134.5\"/>\n\t\t\t\t</g>\n\t\t\t</svg>\n\t\t)\n\t}\n}\n\nexport default EyeIcon;\n",
  "examples": [{
    "name": "EyeIconExample",
    "description": "",
    "code": "import React, {Component, Fragment} from \"react\";\nimport EyeIcon from \"ps-react/EyeIcon\";\n\nclass EyeIconExample extends Component {\n\tconstructor(props) {\n\t\tsuper(props);\n\t\tthis.state = {}\n\t}\n\n\trender() {\n\t\treturn (\n\t\t\t<Fragment>\n\t\t\t\t<EyeIcon/>\n\t\t\t</Fragment>\n\t\t);\n\t}\n}\n\nexport default EyeIconExample;\n"
  }]
}, {
  "name": "HelloWorld",
  "description": "A hello world component. A very reusable component",
  "props": {
    "message": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Message to display",
      "defaultValue": {
        "value": "\"World\"",
        "computed": false
      }
    },
    "user": {
      "type": {
        "name": "shape",
        "value": {
          "name": {
            "name": "string",
            "required": false
          },
          "age": {
            "name": "number",
            "required": false
          }
        }
      },
      "required": false,
      "description": "Optional user object",
      "defaultValue": {
        "value": "{\n    name : \"\",\n    age: \"\"\n}",
        "computed": false
      }
    }
  },
  "code": "import React, {Component, Fragment} from \"react\";\nimport PropTypes from \"prop-types\";\n\n/**\n * A hello world component. A very reusable component\n */\nclass HelloWorld extends Component {\n\tconstructor(props) {\n\t\tsuper(props);\n\t\tthis.state = {}\n\t}\n\n\tstatic defaultProps = {\n\t\tmessage: \"World\",\n\t\tuser: {\n\t\t\tname : \"\",\n\t\t\tage: \"\"\n\t\t}\n\t};\n\n\trender() {\n\t\treturn (\n\t\t\t<Fragment>\n\t\t\t\tHello {this.props.message}\n\t\t\t</Fragment>\n\t\t);\n\t}\n}\n\nHelloWorld.propTypes = {\n\t/** Message to display */\n\tmessage: PropTypes.string,\n\t/** Optional user object */\n\tuser : PropTypes.shape({\n\t\tname: PropTypes.string,\n\t\tage: PropTypes.number\n\t})\n};\n\nHelloWorld.defaultProps = {\n\tmessage: \"World\",\n\tuser: {\n\t\tname : \"\",\n\t\tage: \"\"\n\t}\n};\n\n\nexport default HelloWorld;\n",
  "examples": [{
    "name": "ExampleHelloWorld",
    "description": "Custom message",
    "code": "import React, {Component, Fragment} from \"react\";\nimport HelloWorld from \"ps-react/HelloWorld\";\n\n/**\n * Custom message\n */\nclass ExampleHelloWorld extends Component {\n\tconstructor(props) {\n\t\tsuper(props);\n\t\tthis.state = {}\n\t}\n\n\trender() {\n\t\treturn (\n\t\t\t<Fragment>\n\t\t\t\t<HelloWorld message=\"Pluralsight\"/>\n\t\t\t</Fragment>\n\t\t);\n\t}\n}\n\nexport default ExampleHelloWorld;\n"
  }]
}, {
  "name": "Label",
  "description": "",
  "props": {
    "htmlFor": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "HTML ID for associated input"
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Label Text"
    },
    "required": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Display an asterisk after label if true"
    }
  },
  "code": "import React, {Component, Fragment} from \"react\";\nimport PropTypes from \"prop-types\";\n\nclass Label extends Component {\n\tconstructor(props) {\n\t\tsuper(props);\n\t\tthis.state = {}\n\t}\n\n\tstatic propTypes = {\n\t\t/** HTML ID for associated input */\n\t\thtmlFor: PropTypes.string.isRequired,\n\t\t/** Label Text */\n\t\tlabel: PropTypes.string.isRequired,\n\t\t/** Display an asterisk after label if true */\n\t\trequired: PropTypes.bool\n\t};\n\n\tstatic defaultProps = {\n\n\t};\n\n\trender() {\n\t\tconst {htmlFor, label, required} = this.props;\n\t\treturn (\n\t\t\t<label style={{color: required ? 'red' : ''}} htmlFor={htmlFor}>\n\t\t\t\t{label}\n\t\t\t\t{\n\t\t\t\t\trequired &&\n\t\t\t\t\t<span > * </span>\n\t\t\t\t}\n\t\t\t</label>\n\t\t);\n\t}\n}\n\nexport default Label;\n",
  "examples": [{
    "name": "ExampleOptional",
    "description": "",
    "code": "import React, {Component, Fragment} from \"react\";\nimport Label from \"ps-react/Label\";\n\nclass ExampleOptional extends Component {\n\tconstructor(props) {\n\t\tsuper(props);\n\t\tthis.state = {}\n\t}\n\n\trender() {\n\t\treturn (\n\t\t\t<Fragment>\n\t\t\t\t<Label htmlFor=\"name\" label=\"Test\"/>\n\t\t\t\t<input type=\"text\" id=\"name\"/>\n\t\t\t</Fragment>\n\t\t);\n\t}\n}\n\nexport default ExampleOptional;\n"
  }, {
    "name": "ExampleRequired",
    "description": "",
    "code": "import React, {Component, Fragment} from \"react\";\nimport Label from \"ps-react/Label\";\n\nclass ExampleRequired extends Component {\n\tconstructor(props) {\n\t\tsuper(props);\n\t\tthis.state = {}\n\t}\n\n\trender() {\n\t\treturn (\n\t\t\t<Fragment>\n\t\t\t\t<Label htmlFor=\"name\" label=\"Test\" required />\n\t\t\t\t<input type=\"text\" id=\"name\"/>\n\t\t\t</Fragment>\n\t\t);\n\t}\n}\n\nexport default ExampleRequired;\n"
  }]
}, {
  "name": "PasswordInput",
  "description": "Password input with integrated label, quality tips, and show password toggle.",
  "props": {
    "htmlId": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Unique HTML ID. Used for tying label to HTML input. Handy hook for automated testing."
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Input name. Recommend setting this to match object's property so a single change handler can be used by convention."
    },
    "value": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": "Password value"
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Input label",
      "defaultValue": {
        "value": "'Password'",
        "computed": false
      }
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "Function called when password input value changes"
    },
    "maxLength": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Max password length accepted",
      "defaultValue": {
        "value": "50",
        "computed": false
      }
    },
    "placeholder": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Placeholder displayed when no password is entered"
    },
    "showVisibilityToggle": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Set to true to show the toggle for displaying the currently entered password",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    },
    "quality": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Display password quality visually via ProgressBar, accepts a number between 0 and 100"
    },
    "error": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Validation error to display"
    }
  },
  "code": "import React from 'react';\nimport PropTypes from 'prop-types';\nimport ProgressBar from '../ProgressBar';\nimport EyeIcon from '../EyeIcon';\nimport TextInput from '../TextInput';\n\n/** Password input with integrated label, quality tips, and show password toggle. */\nclass PasswordInput extends React.Component {\n\tconstructor(props) {\n\t\tsuper(props);\n\t\tthis.state = {\n\t\t\tshowPassword: false\n\t\t}\n\t}\n\n\ttoggleShowPassword = event => {\n\t\tthis.setState(prevState => {\n\t\t\treturn {showPassword: !prevState.showPassword};\n\t\t});\n\t\tif (event) event.preventDefault();\n\t};\n\n\trender() {\n\t\tconst {htmlId, value, label, error, onChange, placeholder, maxLength, showVisibilityToggle, quality, ...props} = this.props;\n\t\tconst {showPassword} = this.state;\n\n\t\treturn (\n\t\t\t<TextInput\n\t\t\t\thtmlId={htmlId}\n\t\t\t\tlabel={label}\n\t\t\t\tplaceholder={placeholder}\n\t\t\t\ttype={showPassword ? 'text' : 'password'}\n\t\t\t\tonChange={onChange}\n\t\t\t\tvalue={value}\n\t\t\t\tmaxLength={maxLength}\n\t\t\t\terror={error}\n\t\t\t\trequired\n\t\t\t\t{...props}>\n\t\t\t\t{\n\t\t\t\t\tshowVisibilityToggle &&\n\t\t\t\t\t<button\n\t\t\t\t\t\tonClick={this.toggleShowPassword}\n\t\t\t\t\t\tstyle={{marginLeft: 5, border: \"none\"}}>\n\t\t\t\t\t\t<EyeIcon/>\n\t\t\t\t\t</button>\n\t\t\t\t}\n\t\t\t\t{\n\t\t\t\t\tvalue.length > 0 && quality && <ProgressBar percent={quality} width={130}/>\n\t\t\t\t}\n\t\t\t</TextInput>\n\t\t);\n\t}\n}\n\nPasswordInput.propTypes = {\n\t/** Unique HTML ID. Used for tying label to HTML input. Handy hook for automated testing. */\n\thtmlId: PropTypes.string.isRequired,\n\n\t/** Input name. Recommend setting this to match object's property so a single change handler can be used by convention.*/\n\tname: PropTypes.string.isRequired,\n\n\t/** Password value */\n\tvalue: PropTypes.any,\n\n\t/** Input label */\n\tlabel: PropTypes.string,\n\n\t/** Function called when password input value changes */\n\tonChange: PropTypes.func.isRequired,\n\n\t/** Max password length accepted */\n\tmaxLength: PropTypes.number,\n\n\t/** Placeholder displayed when no password is entered */\n\tplaceholder: PropTypes.string,\n\n\t/** Set to true to show the toggle for displaying the currently entered password */\n\tshowVisibilityToggle: PropTypes.bool,\n\n\t/** Display password quality visually via ProgressBar, accepts a number between 0 and 100 */\n\tquality: PropTypes.number,\n\n\t/** Validation error to display */\n\terror: PropTypes.string\n};\n\nPasswordInput.defaultProps = {\n\tmaxLength: 50,\n\tshowVisibilityToggle: false,\n\tlabel: 'Password'\n};\n\nexport default PasswordInput;\n",
  "examples": [{
    "name": "ExampleAllFeatures",
    "description": "All features enabled",
    "code": "import React from 'react';\nimport PasswordInput from 'ps-react/PasswordInput';\n\n/** All features enabled */\nclass ExampleAllFeatures extends React.Component {\n\tconstructor(props) {\n\t\tsuper(props);\n\n\t\tthis.state = {\n\t\t\tpassword: ''\n\t\t};\n\t}\n\n\tgetQuality() {\n\t\tconst length = this.state.password.length;\n\t\treturn length > 10 ? 100 : length * 10;\n\t}\n\n\trender() {\n\t\treturn (\n\t\t\t<div>\n\t\t\t\t<PasswordInput\n\t\t\t\t\thtmlId=\"password-input-example-all-features\"\n\t\t\t\t\tname=\"password\"\n\t\t\t\t\tonChange={event => this.setState({password: event.target.value})}\n\t\t\t\t\tvalue={this.state.password}\n\t\t\t\t\tminLength={8}\n\t\t\t\t\tplaceholder=\"Enter password\"\n\t\t\t\t\tshowVisibilityToggle\n\t\t\t\t\tquality={this.getQuality()}\n\t\t\t\t\t{...this.props} />\n\t\t\t</div>\n\t\t)\n\t}\n}\n\nexport default ExampleAllFeatures;\n"
  }]
}, {
  "name": "ProgressBar",
  "description": "",
  "props": {
    "percent": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Percent (number) of progress completed",
      "defaultValue": {
        "value": "0",
        "computed": false
      }
    },
    "width": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Bar width",
      "defaultValue": {
        "value": "0",
        "computed": false
      }
    },
    "height": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Bar height",
      "defaultValue": {
        "value": "5",
        "computed": false
      }
    }
  },
  "code": "import React, {Component, Fragment} from \"react\";\nimport PropTypes from \"prop-types\";\n\nclass ProgressBar extends Component {\n\tconstructor(props) {\n\t\tsuper(props);\n\t\tthis.state = {}\n\t}\n\n\tstatic defaultProps = {\n\t\tpercent: 0,\n\t\twidth: 0,\n\t\theight: 5\n\t};\n\n\tstatic propTypes = {\n\t\t/** Percent (number) of progress completed */\n\t\tpercent: PropTypes.number,\n\t\t/** Bar width  */\n\t\twidth: PropTypes.number,\n\t\t/** Bar height */\n\t\theight: PropTypes.number\n\t};\n\n\tgetColor = () => {\n\t\tconst {percent} = this.props;\n\t\treturn percent === 100 ? 'green' : percent > 50 ? 'lightgreen' : 'red';\n\t};\n\n\tgetWidthAsPercentOfTotalWidth = () => {\n\t\tconst {percent, width} = this.props;\n\t\treturn parseInt(width * ( percent / 100 ), 10);\n\t};\n\n\n\trender() {\n\t\tconst { width, height} = this.props;\n\t\tconst rootStyle = {\n\t\t\tborder: 'solid 1px lightgray',\n\t\t\twidth\n\t\t};\n\t\tconst innerStyle = {\n\t\t\twidth: this.getWidthAsPercentOfTotalWidth(),\n\t\t\theight,\n\t\t\tbackgroundColor: this.getColor()\n\t\t};\n\t\treturn (\n\t\t\t<div style={rootStyle}>\n\t\t\t\t<div style={innerStyle} />\n\t\t\t</div>\n\t\t);\n\t}\n}\n\nexport default ProgressBar;\n",
  "examples": [{
    "name": "ExampleProgressBar10",
    "description": "Example 10%",
    "code": "import React, {Component, Fragment} from \"react\";\nimport ProgressBar from \"../../../components/ProgressBar\";\n\n/** Example 10% */\nclass ExampleProgressBar10 extends Component {\n\tconstructor(props) {\n\t\tsuper(props);\n\t\tthis.state = {}\n\t}\n\n\trender() {\n\t\treturn (\n\t\t\t<Fragment>\n\t\t\t\t<ProgressBar percent={10} width={150}/>\n\t\t\t</Fragment>\n\t\t);\n\t}\n}\n\nexport default ExampleProgressBar10;\n"
  }, {
    "name": "ExampleProgressBar100",
    "description": "Example 100%",
    "code": "import React, {Component, Fragment} from \"react\";\nimport ProgressBar from \"../../../components/ProgressBar\";\n\n/** Example 100% */\nclass ExampleProgressBar100 extends Component {\n\tconstructor(props) {\n\t\tsuper(props);\n\t\tthis.state = {}\n\t}\n\n\trender() {\n\t\treturn (\n\t\t\t<Fragment>\n\t\t\t\t<ProgressBar percent={100} width={150}/>\n\t\t\t</Fragment>\n\t\t);\n\t}\n}\n\nexport default ExampleProgressBar100;\n"
  }, {
    "name": "ExampleProgressBar80",
    "description": "Example 80%",
    "code": "import React, {Component, Fragment} from \"react\";\nimport ProgressBar from \"../../../components/ProgressBar\";\n\n/** Example 80% */\nclass ExampleProgressBar80 extends Component {\n\tconstructor(props) {\n\t\tsuper(props);\n\t\tthis.state = {}\n\t}\n\n\trender() {\n\t\treturn (\n\t\t\t<Fragment>\n\t\t\t\t<ProgressBar percent={80} width={150}/>\n\t\t\t</Fragment>\n\t\t);\n\t}\n}\n\nexport default ExampleProgressBar80;\n"
  }]
}, {
  "name": "RegistrationForm",
  "description": "Registration form with built-in validation.",
  "props": {
    "confirmationMessage": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Message displayed upon successful submission",
      "defaultValue": {
        "value": "\"Thanks for registering!\"",
        "computed": false
      }
    },
    "onSubmit": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "Called when form is submitted"
    },
    "minPasswordLength": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Minimum password length",
      "defaultValue": {
        "value": "8",
        "computed": false
      }
    }
  },
  "code": "import React from 'react';\nimport PropTypes from 'prop-types';\nimport TextInput from '../TextInput';\nimport PasswordInput from '../PasswordInput';\n\n/** Registration form with built-in validation. */\nclass RegistrationForm extends React.Component {\n\tconstructor(props) {\n\t\tsuper(props);\n\n\t\tthis.state = {\n\t\t\tuser: {\n\t\t\t\temail: '',\n\t\t\t\tpassword: ''\n\t\t\t},\n\t\t\terrors: {},\n\t\t\tsubmitted: false,\n\t\t};\n\t}\n\n\tonChange = (event) => {\n\t\tconst user = this.state.user;\n\t\tuser[event.target.name] = event.target.value;\n\t\tthis.setState({user});\n\t}\n\n\t// Returns a number from 0 to 100 that represents password quality.\n\t// For simplicity, just returning % of min length entered.\n\t// Could enhance with checks for number, special char, unique characters, etc.\n\tpasswordQuality(password) {\n\t\tif (!password) return null;\n\t\tif (password.length >= this.props.minPasswordLength) return 100;\n\t\tconst percentOfMinLength = parseInt(password.length / this.props.minPasswordLength * 100, 10);\n\t\treturn percentOfMinLength;\n\t}\n\n\tvalidate({email, password}) {\n\t\tconst errors = {};\n\t\tconst {minPasswordLength} = this.props;\n\n\t\tif (!email) errors.email = 'Email required.';\n\t\tif (password.length < minPasswordLength) errors.password = `Password must be at least ${minPasswordLength} characters.`;\n\n\t\tthis.setState({errors});\n\t\treturn Object.getOwnPropertyNames(errors).length === 0;\n\t}\n\n\tonSubmit = () => {\n\t\tconst {user} = this.state;\n\t\tconst formIsValid = this.validate(user);\n\t\tif (formIsValid) {\n\t\t\tthis.props.onSubmit(user);\n\t\t\tthis.setState({submitted: true});\n\t\t}\n\t}\n\n\trender() {\n\t\tconst {errors, submitted} = this.state;\n\t\tconst {email, password} = this.state.user;\n\n\t\treturn (\n\t\t\tsubmitted ?\n\t\t\t<h2>{this.props.confirmationMessage}</h2> :\n\t\t\t<div>\n\t\t\t\t<TextInput\n\t\t\t\t\thtmlId=\"registration-form-email\"\n\t\t\t\t\tname=\"email\"\n\t\t\t\t\tonChange={this.onChange}\n\t\t\t\t\tlabel=\"Email\"\n\t\t\t\t\tvalue={email}\n\t\t\t\t\terror={errors.email}\n\t\t\t\t\trequired/>\n\n\t\t\t\t<PasswordInput\n\t\t\t\t\thtmlId=\"registration-form-password\"\n\t\t\t\t\tname=\"password\"\n\t\t\t\t\tvalue={password}\n\t\t\t\t\tonChange={this.onChange}\n\t\t\t\t\tquality={this.passwordQuality(password)}\n\t\t\t\t\tshowVisibilityToggle\n\t\t\t\t\tmaxLength={50}\n\t\t\t\t\terror={errors.password}/>\n\n\t\t\t\t<input type=\"submit\" value=\"Register\" onClick={this.onSubmit}/>\n\t\t\t</div>\n\t\t)\n\t}\n}\n\nRegistrationForm.propTypes = {\n\t/** Message displayed upon successful submission */\n\tconfirmationMessage: PropTypes.string,\n\n\t/** Called when form is submitted */\n\tonSubmit: PropTypes.func.isRequired,\n\n\t/** Minimum password length */\n\tminPasswordLength: PropTypes.number\n}\n\nRegistrationForm.defaultProps = {\n\tconfirmationMessage: \"Thanks for registering!\",\n\tminPasswordLength: 8\n};\n\nexport default RegistrationForm;\n",
  "examples": [{
    "name": "ExampleRegistrationForm",
    "description": "",
    "code": "import React from 'react';\nimport RegistrationForm from 'ps-react/RegistrationForm';\n\nexport default class ExampleRegistrationForm extends React.Component {\n  onSubmit = (user) => {\n    console.log(user);\n  };\n\n  render() {\n    return <RegistrationForm onSubmit={this.onSubmit} />\n  }\n}\n"
  }]
}, {
  "name": "TextInput",
  "description": "",
  "props": {
    "htmlId": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Unique HTML ID. Used for tying label to HTML input. Handy hook for automated testing."
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Input name. Recommend setting this to match object's property so a single change handler can be used."
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Input label"
    },
    "type": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'text'",
          "computed": false
        }, {
          "value": "'number'",
          "computed": false
        }, {
          "value": "'password'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Input type"
    },
    "required": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Mark label with asterisk if set to true"
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "Function to call onChange"
    },
    "placeholder": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Placeholder to display when empty"
    },
    "value": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": "Value"
    },
    "error": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "String to display when error occurs"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Child component to display next to the input"
    }
  },
  "code": "import React, {Component, Fragment} from \"react\";\nimport PropTypes from 'prop-types';\nimport Label from \"ps-react/Label\";\n\nclass TextInput extends Component {\n\tconstructor(props) {\n\t\tsuper(props);\n\t\tthis.state = {}\n\t}\n\n\trender() {\n\t\tconst {\n\t\t\thtmlId,\n\t\t\tname,\n\t\t\tlabel,\n\t\t\ttype = \"text\",\n\t\t\trequired = false,\n\t\t\tonChange,\n\t\t\tplaceholder,\n\t\t\tvalue,\n\t\t\terror,\n\t\t\tchildren,\n\t\t\t...props\n\t\t} = this.props;\n\t\treturn (\n\t\t\t<div style={{marginBottom: 16}}>\n\t\t\t\t<Label htmlFor={htmlId} label={label} required={required}/>\n\t\t\t\t<input\n\t\t\t\t\tid={htmlId}\n\t\t\t\t\ttype={type}\n\t\t\t\t\tname={name}\n\t\t\t\t\tplaceholder={placeholder}\n\t\t\t\t\tvalue={value}\n\t\t\t\t\tonChange={onChange}\n\t\t\t\t\tstyle={error && {border: 'solid 1px red'}}\n\t\t\t\t\t{...props}/>\n\t\t\t\t{children}\n\t\t\t\t{error && <div className=\"error\" style={{color: 'red'}}>{error}</div>}\n\t\t\t</div>\n\t\t);\n\t}\n}\n\nTextInput.propTypes = {\n\t/** Unique HTML ID. Used for tying label to HTML input. Handy hook for automated testing. */\n\thtmlId: PropTypes.string.isRequired,\n\t/** Input name. Recommend setting this to match object's property so a single change handler can be used. */\n\tname: PropTypes.string.isRequired,\n\t/** Input label */\n\tlabel: PropTypes.string.isRequired,\n\t/** Input type */\n\ttype: PropTypes.oneOf(['text', 'number', 'password']),\n\t/** Mark label with asterisk if set to true */\n\trequired: PropTypes.bool,\n\t/** Function to call onChange */\n\tonChange: PropTypes.func.isRequired,\n\t/** Placeholder to display when empty */\n\tplaceholder: PropTypes.string,\n\t/** Value */\n\tvalue: PropTypes.any,\n\t/** String to display when error occurs */\n\terror: PropTypes.string,\n\t/** Child component to display next to the input */\n\tchildren: PropTypes.node\n};\n\n\nexport default TextInput;\n",
  "examples": [{
    "name": "ExampleError",
    "description": "",
    "code": "import React, {Component, Fragment} from \"react\";\nimport TextInput from \"ps-react/TextInput\";\n\nclass ExampleError extends Component {\n\tconstructor(props) {\n\t\tsuper(props);\n\t\tthis.state = {}\n\t}\n\n\trender() {\n\t\treturn (\n\t\t\t<TextInput\n\t\t\t\thtmlId=\"example-optional\"\n\t\t\t\tname=\"firstname\"\n\t\t\t\tlabel=\"First name\"\n\t\t\t\tonChange={this.handleChange }\n\t\t\t\trequired\n\t\t\t\terror=\"First name is required\"\n\t\t\t/>\n\t\t);\n\t}\n}\n\nexport default ExampleError;\n"
  }, {
    "name": "ExampleOptional",
    "description": "",
    "code": "import React, {Component, Fragment} from \"react\";\nimport TextInput from \"ps-react/TextInput\";\n\nclass ExampleOptional extends Component {\n\tconstructor(props) {\n\t\tsuper(props);\n\t\tthis.state = {\n\t\t\tvalue: \"\"\n\t\t}\n\t}\n\n\thandleChange = e => {\n\t\tthis.setState({[e.target.name] : e.target.value});\n\t};\n\n\trender() {\n\t\treturn (\n\t\t\t<Fragment>\n\t\t\t\t<TextInput\n\t\t\t\t\thtmlId=\"example-optional\"\n\t\t\t\t\tname=\"firstname\"\n\t\t\t\t\tlabel=\"First name\"\n\t\t\t\t\tonChange={this.handleChange }\n\t\t\t\t/>\n\t\t\t</Fragment>\n\t\t);\n\t}\n}\n\nexport default ExampleOptional;\n"
  }]
}, {
  "name": "TextInputBEM",
  "description": "Text input with integrated label to enforce consistency in layout, error display, label placement, and required field marker.",
  "props": {
    "htmlId": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Unique HTML ID. Used for tying label to HTML input. Handy hook for automated testing."
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Input name. Recommend setting this to match object's property so a single change handler can be used."
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Input label"
    },
    "type": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'text'",
          "computed": false
        }, {
          "value": "'number'",
          "computed": false
        }, {
          "value": "'password'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Input type",
      "defaultValue": {
        "value": "\"text\"",
        "computed": false
      }
    },
    "required": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Mark label with asterisk if set to true",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "Function to call onChange"
    },
    "placeholder": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Placeholder to display when empty"
    },
    "value": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": "Value"
    },
    "error": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "String to display when error occurs"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Child component to display next to the input"
    }
  },
  "code": "import React from 'react';\nimport PropTypes from 'prop-types';\nimport Label from '../Label';\n\n/** Text input with integrated label to enforce consistency in layout, error display, label placement, and required field marker. */\nconst TextInput = (\n\t{\n\t\thtmlId,\n\t\tname,\n\t\tlabel,\n\t\ttype = \"text\",\n\t\trequired = false,\n\t\tonChange,\n\t\tplaceholder,\n\t\tvalue,\n\t\terror,\n\t\tchildren,\n\t\t...props\n\t}\n) =>\n\t(\n\t\t<div className=\"textinput\">\n\t\t\t<Label htmlFor={htmlId} label={label} required={required}/>\n\t\t\t<input\n\t\t\t\tid={htmlId}\n\t\t\t\ttype={type}\n\t\t\t\tname={name}\n\t\t\t\tplaceholder={placeholder}\n\t\t\t\tvalue={value}\n\t\t\t\tonChange={onChange}\n\t\t\t\tclassName={error && 'textinput__input--state-error'}\n\t\t\t\t{...props}/>\n\t\t\t{children}\n\t\t\t{error && <div className=\"textinput__error\">{error}</div>}\n\t\t</div>\n\t);\n\nTextInput.propTypes = {\n\t/** Unique HTML ID. Used for tying label to HTML input. Handy hook for automated testing. */\n\thtmlId: PropTypes.string.isRequired,\n\n\t/** Input name. Recommend setting this to match object's property so a single change handler can be used. */\n\tname: PropTypes.string.isRequired,\n\n\t/** Input label */\n\tlabel: PropTypes.string.isRequired,\n\n\t/** Input type */\n\ttype: PropTypes.oneOf(['text', 'number', 'password']),\n\n\t/** Mark label with asterisk if set to true */\n\trequired: PropTypes.bool,\n\n\t/** Function to call onChange */\n\tonChange: PropTypes.func.isRequired,\n\n\t/** Placeholder to display when empty */\n\tplaceholder: PropTypes.string,\n\n\t/** Value */\n\tvalue: PropTypes.any,\n\n\t/** String to display when error occurs */\n\terror: PropTypes.string,\n\n\t/** Child component to display next to the input */\n\tchildren: PropTypes.node\n};\n\nexport default TextInput;\n",
  "examples": [{
    "name": "ExampleError",
    "description": "Required TextBox with error",
    "code": "import React from 'react';\nimport TextInputBEM from 'ps-react/TextInputBEM';\n\n/** Required TextBox with error */\nexport default class ExampleError extends React.Component {\n\trender() {\n\t\treturn (\n\t\t\t<TextInputBEM\n\t\t\t\thtmlId=\"example-optional\"\n\t\t\t\tlabel=\"First Name\"\n\t\t\t\tname=\"firstname\"\n\t\t\t\tonChange={() => {\n\t\t\t\t}}\n\t\t\t\trequired\n\t\t\t\terror=\"First name is required.\"\n\t\t\t/>\n\t\t)\n\t}\n}\n"
  }]
}, {
  "name": "TextInputCSSModules",
  "description": "Text input with integrated label to enforce consistency in layout, error display, label placement, and required field marker.",
  "props": {
    "htmlId": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Unique HTML ID. Used for tying label to HTML input. Handy hook for automated testing."
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Input name. Recommend setting this to match object's property so a single change handler can be used."
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Input label"
    },
    "type": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'text'",
          "computed": false
        }, {
          "value": "'number'",
          "computed": false
        }, {
          "value": "'password'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Input type",
      "defaultValue": {
        "value": "\"text\"",
        "computed": false
      }
    },
    "required": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Mark label with asterisk if set to true",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "Function to call onChange"
    },
    "placeholder": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Placeholder to display when empty"
    },
    "value": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": "Value"
    },
    "error": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "String to display when error occurs"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Child component to display next to the input"
    }
  },
  "code": "import React from 'react';\nimport PropTypes from 'prop-types';\nimport Label from '../Label';\nimport styles from './textInput.module.css';\n\n/** Text input with integrated label to enforce consistency in layout, error display, label placement, and required field marker. */\nfunction TextInput({htmlId, name, label, type = \"text\", required = false, onChange, placeholder, value, error, children, ...props}) {\n\treturn (\n\t\t<div className={styles.fieldset}>\n\t\t\t<Label htmlFor={htmlId} label={label} required={required}/>\n\t\t\t<input\n\t\t\t\tid={htmlId}\n\t\t\t\ttype={type}\n\t\t\t\tname={name}\n\t\t\t\tplaceholder={placeholder}\n\t\t\t\tvalue={value}\n\t\t\t\tonChange={onChange}\n\t\t\t\tclassName={error && styles.inputError}\n\t\t\t\t{...props}/>\n\t\t\t{children}\n\t\t\t{error && <div className={styles.error}>{error}</div>}\n\t\t</div>\n\t);\n};\n\nTextInput.propTypes = {\n\t/** Unique HTML ID. Used for tying label to HTML input. Handy hook for automated testing. */\n\thtmlId: PropTypes.string.isRequired,\n\n\t/** Input name. Recommend setting this to match object's property so a single change handler can be used. */\n\tname: PropTypes.string.isRequired,\n\n\t/** Input label */\n\tlabel: PropTypes.string.isRequired,\n\n\t/** Input type */\n\ttype: PropTypes.oneOf(['text', 'number', 'password']),\n\n\t/** Mark label with asterisk if set to true */\n\trequired: PropTypes.bool,\n\n\t/** Function to call onChange */\n\tonChange: PropTypes.func.isRequired,\n\n\t/** Placeholder to display when empty */\n\tplaceholder: PropTypes.string,\n\n\t/** Value */\n\tvalue: PropTypes.any,\n\n\t/** String to display when error occurs */\n\terror: PropTypes.string,\n\n\t/** Child component to display next to the input */\n\tchildren: PropTypes.node\n};\n\nexport default TextInput;\n",
  "examples": [{
    "name": "ExampleError",
    "description": "Required TextBox with error",
    "code": "import React from 'react';\nimport TextInputCSSModules from 'ps-react/TextInputCSSModules';\n\n/** Required TextBox with error */\nexport default class ExampleError extends React.Component {\n\trender() {\n\t\treturn (\n\t\t\t<TextInputCSSModules\n\t\t\t\thtmlId=\"example-optional\"\n\t\t\t\tlabel=\"First Name\"\n\t\t\t\tname=\"firstname\"\n\t\t\t\tonChange={() => {\n\t\t\t\t}}\n\t\t\t\trequired\n\t\t\t\terror=\"First name is required.\"\n\t\t\t/>\n\t\t)\n\t}\n}\n"
  }]
}, {
  "name": "TextInputStyledComponents",
  "description": "Text input with integrated label to enforce consistency in layout, error display, label placement, and required field marker.",
  "props": {
    "htmlId": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Unique HTML ID. Used for tying label to HTML input. Handy hook for automated testing."
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Input name. Recommend setting this to match object's property so a single change handler can be used."
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Input label"
    },
    "type": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'text'",
          "computed": false
        }, {
          "value": "'number'",
          "computed": false
        }, {
          "value": "'password'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Input type",
      "defaultValue": {
        "value": "\"text\"",
        "computed": false
      }
    },
    "required": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Mark label with asterisk if set to true",
      "defaultValue": {
        "value": "false",
        "computed": false
      }
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "Function to call onChange"
    },
    "placeholder": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Placeholder to display when empty"
    },
    "value": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": "Value"
    },
    "error": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "String to display when error occurs"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Child component to display next to the input"
    }
  },
  "code": "import React from 'react';\nimport PropTypes from 'prop-types';\nimport Label from '../Label';\nimport styled from 'styled-components';\n\n/** Text input with integrated label to enforce consistency in layout, error display, label placement, and required field marker. */\nfunction TextInput({htmlId, name, label, type = \"text\", required = false, onChange, placeholder, value, error, children, ...props}) {\n\tconst Error = styled.div`\n    color: red;\n  `;\n\n\tconst Input = styled.input`\n    border: ${error && 'solid 1px red'};\n    display: block;\n  `;\n\n\tconst Fieldset = styled.div`\n    margin-bottom: 16px;\n  `;\n\n\treturn (\n\t\t<Fieldset>\n\t\t\t<Label htmlFor={htmlId} label={label} required={required}/>\n\t\t\t<Input\n\t\t\t\tid={htmlId}\n\t\t\t\ttype={type}\n\t\t\t\tname={name}\n\t\t\t\tplaceholder={placeholder}\n\t\t\t\tvalue={value}\n\t\t\t\tonChange={onChange}\n\t\t\t\t{...props}/>\n\t\t\t{children}\n\t\t\t{error && <Error>{error}</Error>}\n\t\t</Fieldset>\n\t);\n};\n\nTextInput.propTypes = {\n\t/** Unique HTML ID. Used for tying label to HTML input. Handy hook for automated testing. */\n\thtmlId: PropTypes.string.isRequired,\n\n\t/** Input name. Recommend setting this to match object's property so a single change handler can be used. */\n\tname: PropTypes.string.isRequired,\n\n\t/** Input label */\n\tlabel: PropTypes.string.isRequired,\n\n\t/** Input type */\n\ttype: PropTypes.oneOf(['text', 'number', 'password']),\n\n\t/** Mark label with asterisk if set to true */\n\trequired: PropTypes.bool,\n\n\t/** Function to call onChange */\n\tonChange: PropTypes.func.isRequired,\n\n\t/** Placeholder to display when empty */\n\tplaceholder: PropTypes.string,\n\n\t/** Value */\n\tvalue: PropTypes.any,\n\n\t/** String to display when error occurs */\n\terror: PropTypes.string,\n\n\t/** Child component to display next to the input */\n\tchildren: PropTypes.node\n};\n\nexport default TextInput;\n",
  "examples": [{
    "name": "ExampleError",
    "description": "Required TextBox with error",
    "code": "import React from 'react';\nimport TextInputStyledComponents from 'ps-react/TextInputStyledComponents';\n\n/** Required TextBox with error */\nexport default class ExampleError extends React.Component {\n\trender() {\n\t\treturn (\n\t\t\t<TextInputStyledComponents\n\t\t\t\thtmlId=\"example-optional\"\n\t\t\t\tlabel=\"First Name\"\n\t\t\t\tname=\"firstname\"\n\t\t\t\tonChange={() => {\n\t\t\t\t}}\n\t\t\t\trequired\n\t\t\t\terror=\"First name is required.\"\n\t\t\t/>\n\t\t)\n\t}\n}\n"
  }]
}];